<template>
    <div>
        <el-drawer
            :visible.sync="showModal"
            append-to-body
            direction="btt"
            @closed="resetForm"
            size="95%"
            :style="{
                maxWidth: '500px',
                left: '50%',
                transform: 'translateX(-50%)',
            }"
        >
            <template slot="title" class="mb-0">
                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                    <el-tag type="success">
                        <i class="el-icon-plus"></i>
                    </el-tag>
                    <h5 class="font-weight-semibold mb-0">Nova Notificação</h5>
                </div>
            </template>

            <div class="px-4 pb-3 d-flex flex-grow-1 flex-column justify-content-between" :style="{ height: '100%' }">
                <el-form
                    :model="payload"
                    ref="notificacaoForm"
                    label-position="top"
                    status-icon
                >
                    <el-row :gutter="12">
                        <!-- Titulo -->
                        <el-col>
                            <el-form-item
                                prop="title"
                                :rules="[
                                    { required: true, message: 'O título é obrigatório' },
                                    { validator: validateMin(3, 'O título deve possuir no mínimo 3 caracteres'), trigger: 'blur' },
                                    { max: 255, message: 'O título deve possuir no máximo 255 caracteres', trigger: 'blur' },
                                ]"
                            >
                                <label>Título</label>
                                <el-input
                                    v-model="payload.title"
                                    placeholder="Digite o título"
                                    :disabled="isSubmiting"
                                    maxlength="255"
                                    clearable
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Corpo -->
                        <el-col>
                            <el-form-item
                                prop="body"
                                :rules="[
                                    { required: true, message: 'A mensagem é obrigatória' },
                                ]"
                            >
                                <label>Mensagem</label>
                                <el-input
                                    v-model="payload.body"
                                    type="textarea"
                                    :rows="4"
                                    placeholder="Digite a mensagem"
                                    :disabled="isSubmiting"
                                />
                            </el-form-item>
                        </el-col>

                        <!-- Frequencia -->
                        <el-col>
                            <el-form-item
                                prop="frequencia"
                                :rules="[
                                    { required: true, message: 'A frequência é obrigatória', trigger: 'change' },
                                ]"
                            >
                                <label>Frequência</label>
                                <el-select
                                    v-model="payload.frequencia"
                                    placeholder="Selecione a frequência"
                                    :disabled="isSubmiting"
                                    class="w-100"
                                >
                                    <el-option
                                        v-for="frequencia in frequencias"
                                        :key="frequencia.value"
                                        :label="frequencia.text"
                                        :value="frequencia.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <!-- Classe -->
                        <el-col>
                            <el-form-item
                                prop="classe"
                                :rules="[
                                    { required: true, message: 'A classe é obrigatória', trigger: 'change' },
                                ]"
                            >
                                <label>Classe</label>
                                <el-select
                                    v-model="payload.classe"
                                    placeholder="Selecione uma classe"
                                    :disabled="isSubmiting"
                                    class="w-100"
                                >
                                    <el-option
                                        v-for="classe in classes"
                                        :key="classe.value"
                                        :label="classe.text"
                                        :value="classe.value"
                                    />
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <!-- Enviar em -->
                        <!-- <el-col>
                            <el-form-item
                                prop="enviar_em"
                                :rules="[
                                    { required: true, message: 'A data de envio é obrigatória', trigger: 'change' },
                                ]"
                            >
                                <label>Enviar em</label>
                                <el-date-picker
                                    v-model="payload.enviar_em"
                                    type="datetime"
                                    placeholder="Selecione data e hora"
                                    format="dd/MM/yyyy HH:mm"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    :disabled="isSubmiting"
                                    class="w-100"
                                />
                            </el-form-item>
                        </el-col> -->

                        <el-col>
                            <el-divider class="my-1"></el-divider>
                        </el-col>

                        <!-- Ativo -->
                        <el-col>
                            <div class="bg-white border rounded-lg p-2 d-flex align-items-center justify-content-between mb-3" :style="{ gap: '12px' }">
                                <div class="d-flex align-items-center" :style="{ gap: '8px' }">
                                    <el-button :type="payload.ativo ? 'success': 'danger'" plain circle :style="{ pointerEvents: 'none' }">
                                        <i v-if="payload.ativo" class="el-icon-unlock"></i>
                                        <i v-else class="el-icon-lock"></i>
                                    </el-button>
                                    <h6 class="mb-0 font-weight-bold">Notificação {{ payload.ativo ? 'Ativa' : 'Inativa' }}</h6>
                                </div>

                                <el-form-item class="mb-0">
                                    <el-switch
                                        v-model="payload.ativo"
                                        active-text="Ativa"
                                        inactive-text="Inativa"
                                    />
                                </el-form-item>
                            </div>
                        </el-col>
                    </el-row>
                </el-form>

                <!-- Actions -->
                <el-row class="mt-3">
                    <el-col>
                        <div class="d-flex align-items-center justify-content-end">
                            <el-button
                                plain
                                type="danger"
                                :disabled="isSubmiting"
                                @click="() => {
                                    toggleModal();
                                    resetForm();
                                }"
                            >
                                Cancelar
                            </el-button>

                            <el-button
                                type="primary"
                                :disabled="isSubmiting"
                                @click="onSubmit"
                            >
                                Salvar
                                <i v-if="isSubmiting" class="el-icon-loading"></i>
                                <i v-else class="el-icon-right"></i>
                            </el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </el-drawer>
    </div>
</template>
<script>
    // Components
    import {
        Row,
        Col,
        Button,
        Input,
        Notification,
        DatePicker,
        Drawer,
        Switch,
        Select,
        Option,
        Divider,
        Tag,
    } from "element-ui";

    // Utils
    import { validateMin } from "@/schemas/generalSchema";

    // Api
    import { NotificacaoApi } from "@/api/NotificacaoApi";

    const notificacaoApi = new NotificacaoApi();

    const emptyPayload = () => ({
        title: null,
        body: null,
        frequencia: 'sem_limite',
        classe: 'Todas',
        // enviar_em: null,
        ativo: true,
    });

    export default {
        data() {
            return {
                payload: emptyPayload(),
                showModal: false,
                isSubmiting: false,
                frequencias: [
                    { text: 'Sem limite', value: 'sem_limite' },
                    { text: 'Diária', value: 'diaria' },
                    { text: 'Semanal', value: 'semanal' },
                    { text: 'Mensal', value: 'mensal' },
                ],
                classes: [
                    { text: 'A', value: 'A' },
                    { text: 'G', value: 'G' },
                    { text: 'V', value: 'V' },
                    { text: 'L', value: 'L' },
                    { text: 'P', value: 'P' },
                    { text: 'B', value: 'B' },
                    { text: 'D', value: 'D' },
                    { text: 'S', value: 'S' },
                ],
            }
        },
        methods: {
            onSubmit() {
                this.$refs.notificacaoForm.validate( async (valid) => {
                    if (!valid) {
                        this.$message({
                            message: 'Atenção, há campo(s) obrigatório(s) não preenchido(s)',
                            type: 'warning',
                            showClose: true,
                        });

                        return false
                    }

                    this.isSubmiting = true;

                    try {
                        await notificacaoApi.store(this.payload);

                        Notification.success({
                            title: 'Sucesso',
                            message: 'Notificação criada com sucesso!'
                        });

                        this.toggleModal();
                        this.resetForm();
                        this.$emit('created');
                    } catch (error) {
                        if (error?.response?.status == 422) {
                            if (error?.response?.data.errors) {
                                Object.values(error.response.data.errors)
                                .flat()
                                .forEach(err_message => {
                                    Notification.warning({
                                        title: 'Atenção',
                                        message: err_message
                                    });
                                });
                            }

                            return
                        }

                        Notification.error({
                            title: 'Erro',
                            message: error?.response?.data?.message ?? 'Não foi possível criar a notificação!'
                        });
                    } finally {
                        this.isSubmiting = false;
                    }
                })
            },
            /**Modal */
            toggleModal() {
                this.showModal = !this.showModal;
            },
            resetForm() {
                this.payload = emptyPayload();

                this.$nextTick(() => {
                    this.$refs.notificacaoForm?.clearValidate();
                });
            },
            /**
             * Utils, Helpers
             */
            validateMin,
        },
        components: {
            [Row.name]: Row,
            [Col.name]: Col,
            [Notification.name]: Notification,
            [Button.name]: Button,
            [Input.name]: Input,
            [Drawer.name]: Drawer,
            [Switch.name]: Switch,
            [Select.name]: Select,
            [Option.name]: Option,
            [Divider.name]: Divider,
            [Tag.name]: Tag,
            [DatePicker.name]: DatePicker,
        },
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/_macro/notificacao/NotificacaoCreateModal.vue